import { useContext } from 'react';

import { AnalyticsContext } from './AnalyticsContext';
import { type Analytics } from './types';

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
const useAnalytics = (): Analytics => useContext(AnalyticsContext).analytics;

export default useAnalytics;
